<template lang="pug">
  b-card.border-0.customerCard.tempInput(
    bg-variant="white",
    body-class="p-2"
    @click="selectTempHandler(originalData.id, originalData.type)"
  )
    .row.mb-2
      .col-2.p-0.d-flex.justify-content-center(
        v-show="selectMode"
      )
        input.custom_checker(
          type="checkbox",
          :id="`checkbox-group-${index}`",
          name="selectTemps",
          :checked="isChecked(index)"
          :class="{ 'hidden-check': isChecked(index) }"
        )
        .input_wrap.ml-3
          .custom-check-icon.border-black.mr-2
      .position-relative(
        :class="{ 'col-10': selectMode, 'col-12': !selectMode }"
      )
        span.white-space-pre-line {{ originalData.push_format.text }}
    .row.no-gutters
      div(
        :class="{ 'col-6': editMode, 'col-12': !editMode }"
      ).col-6
        small.font-size-sm.text-gray 建立者：{{ originalData.creator }}
        p.font-size-sm.mb-1 模板名稱：{{ originalData.name }}
      .col-6.text-right.d-flex.justify-content-end(
        v-if="editMode"
      )
        b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.iconEditBtn.mr-2.border-black(
          variant="primary",
          @click.stop.prevent="editHandler(originalData.id)",
          style="background-color: #d9d9d9;width: 30px;height: 30px;"
        )
          i.iconEdit.black.mb-0
        b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.iconDeleteBtn.border-black(
          variant="primary",
          @click.stop.prevent="deleteHandler(originalData.id)",
          style="background-color: #d9d9d9;width: 30px;height: 30px;"
        )
          i.iconDelete.black.mb-0

</template>

<script>
const _ = require('lodash');

export default {
  name: 'text-input',
  props: {
    index: [String, Object, Number],
    // 父層資訊
    originalData: {
      type: Object,
      required: true
    },
    selectMode: {
      type: Boolean,
      default: false
    },
    editMode: {
      type: Boolean,
      default: false
    },
    selectTemps: {
      type: Array,
      default: () => [],
    },
    tempTypes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    selectTempHandler(id, template) {
      const vm = this;
      vm.$emit('selectTempHandler', {
        id,
        template
      });
    },
    editHandler(id) {
      const vm = this;
      vm.$emit('editTempHandler', {
        id
      });
    },
    deleteHandler(id) {
      const vm = this;
      vm.$emit('deleteTempHandler', {
        id
      });
    },
    isChecked() {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.id === vm.originalData.id && val.type === vm.originalData.type);
      if (key) {
        return true;
      }
      return false;
    }
  },
  computed: {
    order() {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.id === vm.originalData.id);
      return parseInt(key);
    },

  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "icon";
  src: url("../../../assets/fonts/icon.eot?hrpp7d");
  src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

i {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1rem;
  margin-bottom: 4px;
}

.card {
  border: 0.2rem solid #000!important;
  border-radius: 0.8rem;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
  &-hasNews {
    &::after {
      content: "";
      position: absolute;
      right: 0.4rem;
      top: 0.4rem;
      background-color: #ef4852;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 50%;
    }
  }
}

.iconEdit:before {
  content: "\e911";
}

.iconDelete:before {
  content: "\e910";
}

.black {
  color: #000000;
}

.iconClose:before {
  content: "\e908";
}

.border-black{
  border: 0.2rem solid #000;
}
.outline-invitation {
  display: block;
  border-radius: 1rem;
  padding: 1rem;
  cursor: pointer;
}
.custom-shadow {
  -webkit-box-shadow: 0.2rem 0.2rem 0 #00000033;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
}

.custom-check-icon {
  width: 2rem;
  height: 2rem;
  background-color: #fff;
  border-radius: 0.4rem;
  margin-right: 1.2rem;
  position: relative;
}

.custom_checker:checked ~ .input_wrap .custom-check-icon {
  background-color: #ef4852;
}

.custom_checker:checked ~ .input_wrap .custom-check-icon::after {
  display: block;
}

.custom-check-icon::after {
  content: '';
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 1.5rem;
  height: 1rem;
  background-image: url(../../../assets/images/icon/check-1.png);
  background-size: 1.5rem;
  background-repeat: no-repeat;
}

.invitation_info {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

input[type="checkbox"], input[type="radio"] {
  position: absolute;
  width: 1px;
  height: 1px;
  display: none;
  opacity: 0;
}
</style>
